import React from 'react';

const ChevronLeftIcon = () => {
  return (
    <svg
      width='6'
      height='10'
      viewBox='0 0 6 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.13938 8.19543C5.39972 8.45578 5.39972 8.87788 5.13937 9.13823C4.87903 9.39858 4.45692 9.39858 4.19657 9.13823L0.196566 5.13823C-0.0558196 4.88585 -0.06465 4.47946 0.176535 4.21635L3.8432 0.216348C4.092 -0.055065 4.51371 -0.0734005 4.78512 0.175394C5.05653 0.424189 5.07487 0.8459 4.82607 1.11731L1.59073 4.64678L5.13938 8.19543Z'
        fill='#5D665F'
      />
    </svg>
  );
};

export default ChevronLeftIcon;
